// src/newsAdmin/index.js — 📰 News (Phase B3): the managers-app composer +
// compliance dashboard.
//
// HEAD OFFICE composes (title + body + optional image + audience: all stores /
// picked stores + pin) and archives; both HO and AREA MANAGERS drill into a
// post's compliance — per-store confirmed % with confirmed/missing NAMES (the
// per-person edge over ToyTalk's per-store confirm). The Worker enforces every
// gate (compose = role admin; compliance = AM auto-scoped to their area) — this
// bundle only decides what to SHOW. Auth = the admin Bearer (DB.getToken).
//
// Image: client-compressed to a bounded data-URL (chat A6-1 canvas pattern).

import { loadList } from '../shared/load-failure.js';   // v131.76 - say WHY a list is empty

import { areaChipsHtml, pickAreaStores } from '../shared/areaPick.js';
import { openStoredFile } from '../shared/open-file.js';   // v129.112 — ONE opener (Head Office's PDF)
// v129.113 — SEVERAL reference files per post (three Head Office colleagues, 13 Aug).
import { MAX_COMPOSE_FILES, addAttachmentFiles, composeChipsHtml, attachLinksHtml, openFromPayload, wireDropZone, paintFileState, refusedSendOk } from '../shared/attachments-ui.js';

function esc(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function api(path, opts) {
  opts = opts || {};
  var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
  var headers = { 'Content-Type': 'application/json' };
  var tk = (typeof DB !== 'undefined' && DB.getToken) ? DB.getToken() : null;
  if (tk) headers['Authorization'] = 'Bearer ' + tk;
  return fetch(base + path, { method: opts.method || 'GET', headers: headers, body: opts.body, cache: 'no-store' });
}
function toast(msg, kind) {
  if (typeof showToast !== 'undefined') showToast(msg, kind || 'success');
}

var _posts = [];
var _isHO = false;
var _amMode = false;   // v131.53 (an area manager) - area_manager: composer on, audience locked to their area (the v126.81 Tasks pattern)
var _canCompliance = false;   // admin + area_manager (the Worker enforces the same)
var _pendingImages = [];    // compressed data-URLs awaiting post (up to 3, D1)
var _openCompliance = null; // post id with the drill-in open
var _openComments = null;   // post id with the moderation thread open
var _editingId = null;      // v126.68 — the post being edited (composer in edit mode)
var _briefCfg = { enabled: false, ai: true };   // Daily Store Brief config (HO panel)
var _toyCfg = { enabled: false, domains: [] };   // v132.4 — 🧸 This week in toys (HO panel)

function root() { return document.getElementById('newsAdminRoot'); }
function fmtWhen(iso) {
  try {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  } catch (e) { return ''; }
}

var _styled = false;
function ensureStyles() {
  if (_styled) return;
  _styled = true;
  var css = '' +
    '#newsAdminRoot .na-wrap{max-width:760px}' +
    '#newsAdminRoot .na-compose{background:var(--card);border:1px solid var(--border);border-radius:12px;padding:16px;margin-bottom:16px}' +
    '#newsAdminRoot .na-compose h3{margin:0 0 10px;font-size:15px;color:var(--brand,#009E3D)}' +
    '#newsAdminRoot .na-brief{background:var(--adm-comms-brief-bg);border:1px solid var(--adm-comms-brief-line);border-radius:12px;padding:14px 16px;margin-bottom:16px}' +
    '#newsAdminRoot .na-brief h3{margin:0 0 6px;font-size:14.5px;color:var(--brand,#009E3D)}' +
    '#newsAdminRoot .na-brief .na-prev{background:var(--card);border:1px solid var(--border);border-radius:8px;padding:10px 12px;margin-top:8px;font-size:12.5px}' +
    '#newsAdminRoot .na-brief .na-prev b{color:var(--text,#111b21)}' +
    '#newsAdminRoot .na-in{width:100%;padding:9px 10px;border:1px solid var(--border-strong);border-radius:8px;font-size:13.5px;margin-bottom:8px;box-sizing:border-box;font-family:inherit}' +
    '#newsAdminRoot textarea.na-in{min-height:110px;resize:vertical}' +
    '#newsAdminRoot .na-row{display:flex;gap:10px;align-items:center;flex-wrap:wrap;margin-bottom:8px;font-size:13px}' +
    '#newsAdminRoot .na-stores{max-height:160px;overflow-y:auto;border:1px solid var(--border);border-radius:8px;padding:8px;font-size:12.5px;columns:2}' +
    '#newsAdminRoot .na-go{background:var(--brand,#009E3D);color:#fff;border:none;border-radius:8px;padding:10px 18px;font-weight:700;font-size:13.5px;cursor:pointer}' +
    '#newsAdminRoot .na-card{background:var(--card);border:1px solid var(--border);border-radius:10px;padding:12px 14px;margin-bottom:10px}' +
    '#newsAdminRoot .na-title{font-weight:700;font-size:14.5px;color:var(--text,#111b21);display:flex;gap:6px;align-items:center;flex-wrap:wrap}' +
    // v136 dark mode: the yellow pinned chip is a filled label, dark text on yellow, and reads the same in both themes.
    '#newsAdminRoot .na-chip{font-size:10px;font-weight:800;background:#ffd54f;color:#5d4a00;border-radius:8px;padding:1px 7px}' +
    '#newsAdminRoot .na-arch{font-size:10px;font-weight:800;background:var(--surface-3);color:var(--sub,#546e7a);border-radius:8px;padding:1px 7px}' +
    '#newsAdminRoot .na-meta{font-size:11.5px;color:var(--tiny,#8696a0);margin-top:4px}' +
    '#newsAdminRoot .na-actions{margin-top:8px;display:flex;gap:8px;flex-wrap:wrap}' +
    '#newsAdminRoot .na-btn{background:var(--bg,#f0f2f5);border:none;border-radius:8px;padding:6px 12px;font-size:12.5px;font-weight:600;cursor:pointer;color:var(--text,#111b21)}' +
    '#newsAdminRoot .na-comp{margin-top:10px;border-top:1px solid var(--bg,#f0f2f5);padding-top:10px}' +
    '#newsAdminRoot .na-bar{height:8px;border-radius:4px;background:var(--surface-3);overflow:hidden;margin:4px 0 8px}' +
    '#newsAdminRoot .na-fill{height:100%;background:var(--brand,#009E3D)}' +
    '#newsAdminRoot .na-store{font-size:12.5px;margin-bottom:8px}' +
    '#newsAdminRoot .na-names{font-size:11.5px;color:var(--sub,#546e7a);margin-top:2px}';
  var el = document.createElement('style');
  el.id = 'newsAdminStyles';
  el.textContent = css;
  document.head.appendChild(el);
}

// ── Entry (called when the admin News tab opens) ─────────────────────────────
function render() {
  ensureStyles();
  var acct = (typeof currentAdmin !== 'undefined' && currentAdmin) ? currentAdmin : null;
  _isHO = !!(acct && String(acct.role).toLowerCase() === 'admin');
  _amMode = !!(acct && String(acct.role).toLowerCase() === 'area_manager');   // v131.53
  _canCompliance = !!(acct && ['admin', 'area_manager'].indexOf(String(acct.role).toLowerCase()) !== -1);
  paint();
  refresh();
  if (_isHO) { loadBriefConfig(); loadToyNewsConfig(); }   // v132.4
}

// Daily Store Brief — HO panel (Preview / Post now / auto-on toggle) ───────────
async function loadBriefConfig() {
  try {
    var res = await api('/api/admin/daily-brief');
    var d = await res.json().catch(function () { return {}; });
    if (res.ok && d && d.ok && d.config) { _briefCfg = d.config; var cb = document.getElementById('naBriefOn'); if (cb) cb.checked = !!_briefCfg.enabled; }
  } catch (e) { /* panel still renders with defaults */ }
}
// 🧸 This week in toys — HO panel (v132.4). Same three controls as the brief:
// auto-on toggle, preview (builds the post, writes nothing), post now. The
// sources list is the web-search allow-list; every link is checked against it
// on the Worker before anything posts.
async function loadToyNewsConfig() {
  try {
    var res = await api('/api/admin/toy-news');
    var d = await res.json().catch(function () { return {}; });
    if (res.ok && d && d.ok && d.config) {
      _toyCfg = d.config;
      var cb = document.getElementById('naToyOn'); if (cb) cb.checked = !!_toyCfg.enabled;
      var ta = document.getElementById('naToyDomains'); if (ta) ta.value = (_toyCfg.domains || []).join(', ');
    }
  } catch (e) { /* panel still renders with defaults */ }
}
function toyNewsPanelHtml() {
  return '<div class="na-brief"><h3>🧸 This week in toys</h3>' +
    '<div style="font-size:12px;color:var(--sub,#546e7a);margin-bottom:8px">Every Monday morning one post goes to every store: five to eight headlines from UK and UAE toy-retail press with a one-line summary and a link each. Facts only, from the sources below; a week with too little is skipped rather than padded. It is a read, not a compliance item. Preview it first, then switch it on.</div>' +
    '<label style="font-size:13px;display:flex;gap:8px;align-items:center"><input type="checkbox" id="naToyOn"' + (_toyCfg.enabled ? ' checked' : '') + ' onchange="NewsAdmin.setToyNews(this.checked)"> Post automatically every Monday</label>' +
    '<label style="font-size:12px;color:var(--sub,#546e7a);display:block;margin-top:6px">Sources (domains, comma-separated)' +
      '<textarea id="naToyDomains" rows="2" style="display:block;width:100%;box-sizing:border-box;margin-top:4px;font:inherit;font-size:12px;padding:6px;border:1px solid var(--border,#dde3e8);border-radius:8px">' + esc((_toyCfg.domains || []).join(', ')) + '</textarea></label>' +
    '<div class="na-actions"><button class="na-btn" onclick="NewsAdmin.saveToyDomains()">💾 Save sources</button>' +
    '<button class="na-btn" onclick="NewsAdmin.previewToyNews()">👀 Preview this week</button>' +
    '<button class="na-btn" onclick="NewsAdmin.runToyNewsNow()">📤 Post now</button></div>' +
    '<div id="naToyOut">' + (_toyOut || '') + '</div></div>';
}
// v132.15 — the preview takes ~60 s and paint() replaces the whole panel's
// innerHTML whenever the post list refreshes, so the result used to land in
// a detached box and the screen showed nothing. The last output is kept here
// and re-rendered by the panel; writes re-find the box at write time.
var _toyOut = '';
function setToyButtons(disabled) {   // v132.22 — no double presses on a paid search
  var card = document.getElementById('naToyOut') ? document.getElementById('naToyOut').parentElement : null;
  if (card) card.querySelectorAll('button').forEach(function (b) { b.disabled = !!disabled; b.style.opacity = disabled ? '0.55' : ''; });
}
function setToyOut(html) {
  _toyOut = html || '';
  var box = document.getElementById('naToyOut'); if (box) box.innerHTML = _toyOut;
}
async function saveToyConfig(patch) {
  var ta = document.getElementById('naToyDomains');
  var body = { enabled: !!_toyCfg.enabled, domains: ta ? ta.value : (_toyCfg.domains || []) };
  Object.keys(patch || {}).forEach(function (k) { body[k] = patch[k]; });
  var res = await api('/api/admin/toy-news/config', { method: 'POST', body: JSON.stringify(body) });
  var d = await res.json().catch(function () { return {}; });
  if (res.ok && d && d.ok) { _toyCfg = d.config; return true; }
  return false;
}
async function setToyNews(on) {
  try { if (await saveToyConfig({ enabled: !!on })) toast(on ? 'Toy news is ON' : 'Toy news is OFF'); else toast('Could not save', 'error'); }
  catch (e) { toast('No connection — try again', 'error'); }
}
async function saveToyDomains() {
  try { if (await saveToyConfig({})) toast('Sources saved'); else toast('Could not save', 'error'); }
  catch (e) { toast('No connection — try again', 'error'); }
}
function toyPreviewHtml(d) {
  // v135.2: the post itself (title, body, model name) is translate="no"; it goes to staff as written.
  return '<div class="na-prev"><b translate="no">' + esc(d.title) + '</b>' + (d.model ? ' <span translate="no" style="color:var(--tiny,#8696a0)">(' + esc(d.model) + ')</span>' : '') +
    '<div translate="no" style="margin-top:4px;white-space:pre-wrap">' + esc(d.body) + '</div>' +
    // v132.10: the pictures lifted from the articles, as they will appear under the post
    ((d.photos || []).filter(function (p) { return /^data:image\/(jpeg|jpg|png|webp);base64,[A-Za-z0-9+/]+={0,2}$/.test(String(p || '')); }).map(function (p) { return '<img src="' + p + '" alt="" style="max-height:90px;max-width:160px;border-radius:6px;margin:8px 8px 0 0;object-fit:cover">'; }).join('')) +
    (d.dropped && d.dropped.length ? '<div style="font-size:11.5px;color:var(--tiny,#8696a0);margin-top:6px">Dropped: <span translate="no">' + d.dropped.map(esc).join(' ') + '</span></div>' : '') + '</div>';
}
function toyFailText(d) {
  if (!d) return 'Not available';
  var why = d.error || (d.errors && d.errors.length ? d.errors.join(' ') : '') || (d.skipped ? 'Skipped: ' + d.skipped : 'Not available');
  var ms = d.meta && d.meta.ms;
  return why + (ms ? ' (after ' + Math.round(ms / 1000) + 's)' : '');
}
function toyMetaHtml(d) {
  var m = d && d.meta; if (!m || !m.ms) return '';
  // v132.17 — cached previews say so (and offer a fresh search); every run shows what it cost in tokens
  var tok = m.usage && (m.usage.input || m.usage.output) ? ', ~' + Math.round((m.usage.input || 0) / 1000) + 'k tokens in / ' + Math.round((m.usage.output || 0) / 100) / 10 + 'k out' : '';
  var when = m.cached && m.cached_at ? new Date(m.cached_at).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';
  return '<div style="font-size:11px;color:var(--tiny,#8696a0);margin-top:4px">' +
    (m.cached ? 'From the preview searched ' + esc(when) + ' (no new search - Post now uses it too). ' : 'Built in ' + Math.round(m.ms / 1000) + 's' + (m.rounds ? ', ' + m.rounds + ' search round(s)' : '') + tok + '. ') +
    (typeof d.images === 'number' ? d.images + ' picture(s). ' : '') +
    (m.cached ? '<a href="#" onclick="NewsAdmin.previewToyNews(true);return false">Search again</a> (counts against the daily limit of 3)' : '') + '</div>';
}
async function previewToyNews(refresh) {
  if (_toyBusy) return;
  _toyBusy = true; setToyButtons(true);
  setToyOut('<div class="na-prev">⏳ ' + (refresh ? 'Searching again… about a minute. Please do not press again.' : 'Building the preview… a fresh search takes about a minute; a cached one is instant. Please do not press again.') + '</div>');
  try {
    var res = await api('/api/admin/toy-news/run', { method: 'POST', body: JSON.stringify({ preview: true, refresh: !!refresh }) });
    var d = await res.json().catch(function () { return {}; });
    // v132.9 - say WHY it failed (timeout, no usable items, model error) and
    // how long it took, so a slow week is a number and not a mystery.
    if (!res.ok || !d || !d.ok) { setToyOut('<div class="na-prev">' + esc(toyFailText(d)) + '</div>'); return; }
    setToyOut(toyPreviewHtml(d) + toyMetaHtml(d));
  } catch (e) { setToyOut('<div class="na-prev">Could not build a preview - ' + esc((e && e.message) || 'no connection') + '.</div>'); }
  finally { _toyBusy = false; setToyButtons(false); }
}
var _toyBusy = false;
async function runToyNewsNow() {
  if (typeof confirm === 'function' && !confirm('Post this week\'s toy news to every store noticeboard now?\n\nIf you previewed it this week, that preview is what posts (no new search).')) return;
  if (_toyBusy) return;
  _toyBusy = true; setToyButtons(true);
  setToyOut('<div class="na-prev">⏳ Posting… (uses this week\'s preview if there is one; otherwise about a minute). Please do not press again.</div>');
  try {
    var res = await api('/api/admin/toy-news/run', { method: 'POST', body: JSON.stringify({}) });
    var d = await res.json().catch(function () { return {}; });
    if (res.ok && d && d.ok) {
      if (d.skipped === 'already_posted') { toast('Already posted this week'); setToyOut('<div class="na-prev">This week\'s post is already up.</div>'); }
      else { toast('Posted ' + d.items + ' items'); setToyOut('<div class="na-prev">Posted <b translate="no">' + esc(d.title) + '</b> with ' + d.items + ' items' + (d.images ? ' and ' + d.images + ' picture(s)' : '') + '.</div>'); }
      refresh();
    } else { setToyOut('<div class="na-prev">' + esc(toyFailText(d)) + '</div>'); }
  } catch (e) { setToyOut('<div class="na-prev">No connection — try again.</div>'); }
  finally { _toyBusy = false; setToyButtons(false); }
}

function briefPanelHtml() {
  return '<div class="na-brief"><h3>📋 Daily area-manager brief</h3>' +
    '<div style="font-size:12px;color:var(--sub,#546e7a);margin-bottom:8px">Each morning an automatic note is posted to every store from their area manager — sales vs target, tasks still to do today, and the last visit action. Numbers are real; nothing is invented. Preview it first, then switch it on.</div>' +
    '<label style="font-size:13px;display:flex;gap:8px;align-items:center"><input type="checkbox" id="naBriefOn"' + (_briefCfg.enabled ? ' checked' : '') + ' onchange="NewsAdmin.setDaily(this.checked)"> Post automatically every morning</label>' +
    '<div class="na-actions"><button class="na-btn" onclick="NewsAdmin.previewBrief()">👀 Preview today</button>' +
    '<button class="na-btn" onclick="NewsAdmin.runBriefNow()">📤 Post now</button></div>' +
    '<div id="naBriefOut"></div></div>';
}
async function setDaily(on) {
  try {
    var res = await api('/api/admin/daily-brief/config', { method: 'POST', body: JSON.stringify({ enabled: !!on, ai: _briefCfg.ai !== false }) });
    var d = await res.json().catch(function () { return {}; });
    if (res.ok && d && d.ok) { _briefCfg = d.config; toast(on ? 'Daily brief is ON' : 'Daily brief is OFF'); }
    else toast('Could not save', 'error');
  } catch (e) { toast('No connection — try again', 'error'); }
}
async function previewBrief() {
  var out = document.getElementById('naBriefOut'); if (out) out.innerHTML = '<div class="na-prev">Building preview…</div>';
  try {
    var res = await api('/api/admin/daily-brief/run', { method: 'POST', body: JSON.stringify({ preview: true }) });
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || !d || !d.ok) { if (out) out.innerHTML = '<div class="na-prev">' + esc((d && d.error) || 'Not available') + '</div>'; return; }
    var previews = d.previews || [];
    if (!previews.length) { if (out) out.innerHTML = '<div class="na-prev">Nothing to post today — no store has sales, tasks or a recent visit to report.</div>'; return; }
    var html = previews.slice(0, 6).map(function (p) {
      return '<div class="na-prev"><b>' + esc(p.store) + '</b> <span translate="no" style="color:var(--tiny,#8696a0)">(' + esc(p.by) + (p.source === 'template' ? ' · template' : '') + ')</span><div translate="no" style="margin-top:4px;white-space:pre-wrap">' + esc(p.message) + '</div></div>';
    }).join('');
    if (previews.length > 6) html += '<div style="font-size:11.5px;color:var(--tiny,#8696a0);margin-top:6px">…and ' + (previews.length - 6) + ' more store(s).</div>';
    if (out) out.innerHTML = html;
  } catch (e) { if (out) out.innerHTML = '<div class="na-prev">Could not build a preview.</div>'; }
}
async function runBriefNow() {
  if (typeof confirm === 'function' && !confirm('Post the daily brief to every store noticeboard now?')) return;
  var out = document.getElementById('naBriefOut'); if (out) out.innerHTML = '<div class="na-prev">Posting…</div>';
  try {
    var res = await api('/api/admin/daily-brief/run', { method: 'POST', body: JSON.stringify({}) });
    var d = await res.json().catch(function () { return {}; });
    if (res.ok && d && d.ok) {
      toast('Posted to ' + d.posted + ' store(s)');
      if (out) out.innerHTML = '<div class="na-prev">Posted to ' + d.posted + ' store(s). Skipped ' + d.skipped_done + ' already-done and ' + d.skipped_no_signal + ' with nothing to say.</div>';
      refresh();
    } else { if (out) out.innerHTML = '<div class="na-prev">' + esc((d && d.error) || 'Could not post') + '</div>'; }
  } catch (e) { if (out) out.innerHTML = '<div class="na-prev">No connection — try again.</div>'; }
}

// v131.76 - a failed load must not render as an empty list. See
// src/shared/load-failure.js for the incident this comes from.
var _loadError = null;
async function refresh() {
  var r = await loadList(api, '/api/news', 'news posts');
  if (!r.ok) { _loadError = r.message; paint(); return; }
  _loadError = null;
  _posts = r.data.posts || [];
  paint();
}

function storeOptions() {
  // ALL_STORES is an admin.html inline global (name list source of truth).
  var names = [];
  try {
    if (typeof ALL_STORES !== 'undefined' && Array.isArray(ALL_STORES)) {
      names = ALL_STORES.map(function (s) { return typeof s === 'string' ? s : (s && s.name); }).filter(Boolean);
    }
  } catch (e) { /* no list — audience stays "all" */ }
  return names;
}

// Countries derived from the admin.html inline store-lookup core (getStoreCountry).
// v131.53 - the stores an AM may post to: their own area's. Falls back to the
// full list only if the area map is not loaded yet (the Worker is the gate).
function amStoreOptions() {
  try {
    var area = (typeof currentAdmin !== 'undefined' && currentAdmin) ? currentAdmin.area : null;
    if (area != null && typeof AREA_STORE_MAP !== 'undefined' && Array.isArray(AREA_STORE_MAP[area]) && AREA_STORE_MAP[area].length) {
      return AREA_STORE_MAP[area].slice().sort();
    }
  } catch (e) { /* fall through */ }
  return storeOptions();
}

// v131.53 - may THIS viewer edit/archive this post? HO: any. AM: only one
// aimed at picked stores that are ALL in their area (mirrors the Worker's
// amAudienceProblem - the server is authoritative).
function canManagePost(p) {
  if (_isHO) return true;
  if (!_amMode || !p || p.audience !== 'stores' || !Array.isArray(p.stores) || !p.stores.length) return false;
  var mine = {};
  amStoreOptions().forEach(function (n) { mine[n] = true; });
  return p.stores.every(function (n) { return mine[n]; });
}

function countryOptions() {
  var out = [];
  try {
    if (typeof getStoreCountry === 'function') {
      storeOptions().forEach(function (n) {
        var c = getStoreCountry(n);
        if (c && out.indexOf(c) === -1) out.push(c);
      });
    }
  } catch (e) { /* no countries — option hidden */ }
  return out.sort();
}

// v126.71 (Head Office: "search easy" — extended to the manager app lists). A search
// box over the published-post list; re-renders ONLY #naCards so the composer
// (and its in-progress draft) is never disturbed.
var _q = '';
function matchesQ(p) {
  var q = _q.trim().toLowerCase();
  if (!q) return true;
  return ((String(p.title || '') + ' ' + String(p.body || '')).toLowerCase().indexOf(q) !== -1);
}
function cardsHtml() {
  var cards = _posts.filter(matchesQ).map(function (p) {
    var chips = (p.pinned ? '<span class="na-chip">📌 PINNED</span>' : '') + (p.archived ? '<span class="na-arch">ARCHIVED</span>' : '');
    var aud = p.audience === 'stores' ? ((p.stores || []).length + ' store(s)')
      : p.audience === 'country' ? ((p.countries || []).join(', ') || 'Country')
      : 'All stores';
    var actions = '<div class="na-actions">' +
      (_canCompliance ? '<button class="na-btn" onclick="NewsAdmin.toggleCompliance(' + p.id + ')">📊 Compliance</button>' : '') +
      (p.allow_comments ? '<button class="na-btn" onclick="NewsAdmin.toggleComments(' + p.id + ')">💬 Comments</button>' : '') +
      (canManagePost(p) && !p.archived ? '<button class="na-btn" onclick="NewsAdmin.startEdit(' + p.id + ')">✏️ Edit</button>' : '') +
      (canManagePost(p) ? '<button class="na-btn" onclick="NewsAdmin.archive(' + p.id + ',' + (p.archived ? 'false' : 'true') + ')">' + (p.archived ? '↩ Restore' : '🗄 Archive') + '</button>' : '') +
      '</div>';
    var naBody = p.body
      ? '<div class="na-body" translate="no" style="font-size:13px;color:var(--adm-comms-body);line-height:1.5;white-space:pre-wrap;word-break:break-word;margin:4px 0 6px">' + ((typeof RichText !== 'undefined' && RichText.formatRich) ? RichText.formatRich(p.body, { breaks: false }) : esc(p.body)) + '</div>'
      : '';
    return '<div class="na-card">' +
      // v135.2: the title and the author are translate="no"; the audience and "edited" are their own text, so
      // the Arabic layer can swap them.
      '<div class="na-title">' + chips + '<span translate="no">' + esc(p.title) + '</span></div>' +
      naBody +
      '<div class="na-meta"><span>' + esc(aud) + '</span> · <span translate="no">' + esc(p.created_by || '') + '</span> · <span>' + esc(fmtWhen(p.created_at)) + '</span>' + (p.edited_at ? ' · ✏️ edited' : '') + '</div>' +
      // v129.113 — one link per file (was hard-wired to the single row the
      // schema allowed).
      attachLinksHtml(p, 'NewsAdmin.openAttachment', { className: 'na-meta' }) +
      actions + '<div id="naComp' + p.id + '"></div><div id="naCm' + p.id + '"></div></div>';
  }).join('');
  return cards || '<div style="padding:24px;color:var(--tiny,#8696a0);font-size:13.5px">' +
    (_loadError ? esc(_loadError) : (_q.trim() ? 'No posts match "' + esc(_q.trim()) + '".' : 'No posts yet.')) + '</div>';
}
function onSearch(v) {
  _q = String(v == null ? '' : v);
  var c = document.getElementById('naCards');
  if (c) c.innerHTML = cardsHtml();
}

function paint() {
  var el = root(); if (!el) return;
  var brief = _isHO ? briefPanelHtml() + toyNewsPanelHtml() : '';   // v132.4 — the 🧸 card rides next to the brief
  var compose = !(_isHO || _amMode) ? '' :
    '<div class="na-compose"><h3>' + (_editingId ? '✏️ Edit post' : '📰 New post') + '</h3>' +
    (_editingId ? '<div class="na-meta" style="margin:-4px 0 8px">Editing the text &amp; who sees it — pictures / files stay as they are, and confirmations are kept.</div>' : '') +
    '<input id="naTitle" class="na-in" maxlength="200" placeholder="Title">' +
    ((typeof RichText !== 'undefined' && RichText.toolbarHtml) ? RichText.toolbarHtml('naBody') : '') +
    '<textarea id="naBody" class="na-in" maxlength="8000" placeholder="Write the news… (**bold**, *italic*, - bullets, links auto-detect)"></textarea>' +
    // v131.53 - an AM gets ONLY their own area's stores, always visible, no
    // audience radios (publish() forces 'stores'; the Worker enforces the same).
    (_amMode
      ? '<div class="na-row" style="font-weight:700">📍 Your stores (' + esc(String((typeof currentAdmin !== 'undefined' && currentAdmin && currentAdmin.name) || 'your area')) + ')' +
        '<label style="margin-inline-start:auto;font-weight:400"><input type="checkbox" id="naPinned"> 📌 Pin to top</label></div>' +
        '<div id="naStores" class="na-stores" style="display:block">' +
        amStoreOptions().map(function (n) { return '<label style="display:block"><input type="checkbox" class="naStoreCb" value="' + esc(n) + '"> ' + esc(n) + '</label>'; }).join('') +
        '</div>'
      : '<div class="na-row">' +
        '<label><input type="radio" name="naAud" value="all" checked onchange="NewsAdmin.audChanged()"> All stores</label>' +
        (countryOptions().length ? '<label><input type="radio" name="naAud" value="country" onchange="NewsAdmin.audChanged()"> Country</label>' : '') +
        '<label><input type="radio" name="naAud" value="stores" onchange="NewsAdmin.audChanged()"> Selected stores</label>' +
        '<label style="margin-inline-start:auto"><input type="checkbox" id="naPinned"> 📌 Pin to top</label>' +
        '</div>' +
        '<div id="naCountries" class="na-row" style="display:none">' +
        countryOptions().map(function (c) { return '<label><input type="checkbox" class="naCountryCb" value="' + esc(c) + '"> ' + esc(c) + '</label>'; }).join('') +
        '</div>' +
        '<div id="naStores" class="na-stores" style="display:none">' +
        areaChipsHtml('NewsAdmin') +
        storeOptions().map(function (n) { return '<label style="display:block"><input type="checkbox" class="naStoreCb" value="' + esc(n) + '"> ' + esc(n) + '</label>'; }).join('') +
        '</div>') +
    '<div class="na-row"><label><input type="checkbox" id="naComments"> 💬 Allow staff comments (good-news stories)</label></div>' +
    '<div class="na-row">📷 <input type="file" id="naImg" accept="image/*" multiple onchange="NewsAdmin.imgPicked(this)">' +
    '<span id="naImgState" style="font-size:12px;color:var(--tiny,#8696a0)"></span></div>' +
    // v125.84 (Matt: "news is still not letting you preview attachments") — a
    // proper document slot like tasks (v154). PDFs picked into the PICTURE input
    // used to be silently dropped (Head Office's test4 published with nothing attached).
    // v129.113 — `multiple`, with removable chips below.
    '<div class="na-row">📎 <input type="file" id="naFile" multiple accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt" onchange="NewsAdmin.attachPicked(this)">' +
    '<span id="naFileState" style="font-size:12px;color:var(--tiny,#8696a0)">or drag them in</span>' +
    '<div id="naFileChips" style="flex-basis:100%">' + composeChipsHtml(_attachments, 'NewsAdmin.attachRemove') + '</div></div>' +
    '<button class="na-go" id="naGo" onclick="NewsAdmin.publish()">' + (_editingId ? 'Save changes' : 'Publish') + '</button>' +
    (_editingId ? '<button class="na-btn" style="margin-inline-start:8px" onclick="NewsAdmin.cancelEdit()">Cancel</button>' : '') +
    '<div style="font-size:11px;color:var(--tiny,#8696a0);margin-top:8px">Posts show to staff for 7 days (pinned posts stay until unpinned). Up to 3 pictures + one file (PDF / Word / Excel / CSV, max 6 MB).</div></div>';

  // v126.71 — a search box over the list (Head Office). Re-renders ONLY #naCards, so
  // the composer above keeps its in-progress draft.
  var searchBar = _posts.length
    ? '<div style="margin:0 0 10px"><input id="naSearch" value="' + esc(_q) + '" oninput="NewsAdmin.onSearch(this.value)" placeholder="🔍 Search posts…" style="width:100%;max-width:360px;padding:8px 12px;border:1px solid var(--border-strong);border-radius:8px;font-size:13px;box-sizing:border-box"></div>'
    : '';
  el.innerHTML = '<div class="na-wrap">' + brief + compose + searchBar + '<div id="naCards">' + cardsHtml() + '</div></div>';
  // v129.118 (Head Office) — drag files onto the composer, wired once on the
  // PERSISTENT root (paint() replaces innerHTML on every re-render).
  wireDropZone(el, { boxSelector: '.na-compose', onFiles: function (files) { ingestDropped(files); } });
}

function audChanged() {
  var v = document.querySelector('input[name="naAud"]:checked');
  var val = v ? v.value : 'all';
  var stores = document.getElementById('naStores');
  var countries = document.getElementById('naCountries');
  if (stores) stores.style.display = val === 'stores' ? 'block' : 'none';
  if (countries) countries.style.display = val === 'country' ? 'flex' : 'none';
}

// v126.68 — edit a published post. Load its values into the composer, flip the
// composer to edit mode (paint() reads _editingId), scroll to it. publish() then
// PATCHes instead of POSTing. Pictures/attachment are NOT re-loaded — edit is the
// text + audience; media stays as it is on the server.
function startEdit(id) {
  var p = _posts.find(function (x) { return x.id === id; });
  if (!p) return;
  _editingId = id;
  _pendingImages = []; _attachments = []; _refused = null;
  paint();
  prefillComposer(p);
  var c = document.querySelector('#newsAdminRoot .na-compose');
  if (c && c.scrollIntoView) { try { c.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }
}
function cancelEdit() { _editingId = null; _pendingImages = []; _attachments = []; _refused = null; paint(); }
function prefillComposer(p) {
  var t = document.getElementById('naTitle'); if (t) t.value = p.title || '';
  var b = document.getElementById('naBody'); if (b) b.value = p.body || '';
  var pin = document.getElementById('naPinned'); if (pin) pin.checked = !!p.pinned;
  var com = document.getElementById('naComments'); if (com) com.checked = !!p.allow_comments;
  var aud = (p.audience === 'stores' || p.audience === 'country') ? p.audience : 'all';
  var r = document.querySelector('input[name="naAud"][value="' + aud + '"]'); if (r) r.checked = true;
  audChanged();
  var stores = p.stores || [];
  document.querySelectorAll('.naStoreCb').forEach(function (cb) { cb.checked = stores.indexOf(cb.value) !== -1; });
  var countries = p.countries || [];
  document.querySelectorAll('.naCountryCb').forEach(function (cb) { cb.checked = countries.indexOf(cb.value) !== -1; });
}

// Canvas compression (chat A6-1 pattern): max 1280px, stepped JPEG quality,
// hard client cap mirroring the Worker's validatePhoto bound. Up to 3 files (D1).
function compressOne(f) {
  return new Promise(function (resolve) {
    var img = new Image();
    var url = URL.createObjectURL(f);
    img.onload = function () {
      try {
        var scale = Math.min(1, 1280 / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * scale);
        c.height = Math.round(img.height * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        var out = null;
        var qualities = [0.72, 0.55, 0.4];
        for (var i = 0; i < qualities.length; i++) {
          out = c.toDataURL('image/jpeg', qualities[i]);
          if (out.length <= 400000) break;
        }
        resolve(out && out.length <= 400000 ? out : null);
      } catch (e) {
        resolve(null);
      } finally {
        URL.revokeObjectURL(url);
      }
    };
    img.onerror = function () { URL.revokeObjectURL(url); resolve(null); };
    img.src = url;
  });
}

async function imgPicked(input) {
  var files = input && input.files ? Array.prototype.slice.call(input.files, 0, 3) : [];
  var state = document.getElementById('naImgState');
  _pendingImages = [];
  if (!files.length) { if (state) state.textContent = ''; return; }
  if (state) state.textContent = 'Compressing…';
  var failed = 0;
  for (var i = 0; i < files.length; i++) {
    var out = await compressOne(files[i]);
    if (out) _pendingImages.push(out); else failed++;
  }
  if (state) {
    // v125.84 — FAIL LOUD: a non-picture here used to vanish without a word
    // (Head Office's test4 PDF). Name the fix: documents go in the 📎 slot below.
    state.textContent = (_pendingImages.length ? '✓ ' + _pendingImages.length + ' picture(s) ready' : '') +
      (failed ? ' · ' + failed + ' NOT attached (pictures only here — put PDFs/documents in 📎 below)' : '');
    state.style.color = failed ? 'var(--adm-comms-red-text)' : '';
  }
}

// ── v125.84 — one reference file per post (photo OR document), the v154 tasks
// pattern verbatim: FileReader → bounded data URL; the Worker validates
// (allow-listed types, 6MB) and stores it in news_attachments. ──
// v129.113 — SEVERAL of them (three Head Office colleagues, 13 Aug). The mime
// resolution and the 6 MB read moved to src/shared/attachments-ui.js — this file
// and the task composer had grown a byte-identical copy of resolveMime each, and
// making them BOTH multi-file would have meant maintaining two of everything.
// Files ACCUMULATE across picks; the chip row is repainted alone so a repaint
// never wipes a half-written post.
var _attachments = [];
var _refused = null;   // v136.71: what the last pick refused, until a later pick replaces it
function paintAttachChips() {
  var box = document.getElementById('naFileChips');
  if (box) box.innerHTML = composeChipsHtml(_attachments, 'NewsAdmin.attachRemove');
  paintFileState(document.getElementById('naFileState'), _attachments.length, _refused);
}
// v129.118 — the drop path and the picker path share ONE ingest, so a dragged
// file gets exactly the same cap, type check and chip repaint as a picked one.
async function ingestDropped(files) {
  var state = document.getElementById('naFileState');
  if (state) state.textContent = 'Reading\u2026';
  var out = await addAttachmentFiles(_attachments, files);
  _attachments = out.list;
  _refused = out.note || null;   // v136.71
  paintAttachChips();
  if (out.note) toast(out.note, 'error');
}
async function attachPicked(input) {
  var state = document.getElementById('naFileState');
  if (state) state.textContent = 'Reading…';
  var out = await addAttachmentFiles(_attachments, input && input.files);
  _attachments = out.list;
  _refused = out.note || null;   // v136.71: kept, painted red and asked about on Publish
  paintAttachChips();
  // Say what was refused — a silent drop is the bug being fixed.
  if (out.note) toast(out.note, 'error');
  // Clear the input so re-picking the SAME file still fires onchange.
  if (input) { try { input.value = ''; } catch (e) { /* older browsers */ } }
}
function attachRemove(i) {
  _attachments.splice(Number(i), 1);
  paintAttachChips();
}
// v129.113 — `idx` picks which of the post's files to open. openFromPayload
// reads both the new list shape and the old singular one, so this still works
// against a Worker that has not been redeployed yet.
async function openAttachment(postId, idx) {
  try {
    var res = await api('/api/news/attachment?id=' + encodeURIComponent(postId));
    if (!res.ok) { toast('Could not load the attachment', 'error'); return; }
    var d = await res.json();
    if (!d || !d.ok || !openFromPayload(d, Number(idx) || 0)) toast('Could not load the attachment', 'error');
  } catch (e) { toast('Could not load the attachment', 'error'); }
}
// v129.112 — this WAS the fourth copy of the broken opener. The old comment
// claimed "a download is the reliable path"; it is not — a `data:` URL on a
// download anchor is a silent no-op on iOS PWAs and for large files in
// Chrome/Edge, which is exactly the failure Head Office reported on a task PDF.
// Found by sweeping for the pattern after fixing hers, so news attachments
// wouldn't wait for their own bug report.
function openDataUrl(dataUrl, filename, contentType) {
  return openStoredFile(dataUrl, filename, contentType);
}

async function publish() {
  if (_editingId == null && !refusedSendOk(_refused)) return;   // v136.71 (an edit sends no files)
  var title = (document.getElementById('naTitle') || {}).value || '';
  var body = (document.getElementById('naBody') || {}).value || '';
  var audEl = document.querySelector('input[name="naAud"]:checked');
  // v131.53 - an AM has no audience radios: always picked stores (their area).
  var audience = _amMode ? 'stores' : (audEl ? audEl.value : 'all');
  var stores = [];
  if (audience === 'stores') {
    document.querySelectorAll('.naStoreCb:checked').forEach(function (cb) { stores.push(cb.value); });
  }
  var countries = [];
  if (audience === 'country') {
    document.querySelectorAll('.naCountryCb:checked').forEach(function (cb) { countries.push(cb.value); });
  }
  var pinned = !!(document.getElementById('naPinned') || {}).checked;
  var allowComments = !!(document.getElementById('naComments') || {}).checked;
  var editing = _editingId != null;   // v126.68 — edit a published post vs create
  var payload = { title: title, body: body, audience: audience, stores: stores, countries: countries, pinned: pinned, allow_comments: allowComments };
  if (editing) payload.id = _editingId;
  else { payload.images = _pendingImages; payload.attachments = _attachments; }   // v129.113 — the LIST; media only on create
  var btn = document.getElementById('naGo');
  if (btn) { btn.disabled = true; btn.textContent = editing ? 'Saving…' : 'Publishing…'; }
  try {
    var res = await api(editing ? '/api/admin/news/update' : '/api/admin/news', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    var d = await res.json().catch(function () { return {}; });
    if (res.ok && d && d.ok) {
      if (editing) {
        toast('Post updated'); _editingId = null;
      // v125.89 — the post saved but the FILE didn't (the Worker stores it
      // best-effort; a missing news_attachments table = v158 not run on this
      // environment). Say so loudly — a silently dropped file is exactly how
      // Head Office's test posts kept publishing "with" invisible attachments.
      // v129.113 — prefer the server's own note (it names the count and the
      // migration). The v158 line stays as the fallback for an older Worker.
      } else if (d.attachments_note) {
        toast('Published — ' + d.attachments_note, 'error');
      } else if (_attachments.length && d.post && !d.post.attachment_count) {
        toast('Published — but the file was NOT saved. Run migrations/v158-0-news-attachments.sql on this environment, then re-post.', 'error');
      } else {
        toast('Published — target stores get a push');
      }
      _pendingImages = [];
      _attachments = []; _refused = null;
      refresh();
    } else {
      toast((d && d.error) || (editing ? 'Could not save' : 'Could not publish'), 'error');
    }
  } catch (e) {
    toast('No connection — try again', 'error');
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = editing ? 'Save changes' : 'Publish'; }
  }
}

// ── Comment moderation (D1) — view the thread, 🗑 removes (soft) ─────────────
async function toggleComments(id) {
  var slot = document.getElementById('naCm' + id);
  if (!slot) return;
  if (_openComments === id) { _openComments = null; slot.innerHTML = ''; return; }
  _openComments = id;
  slot.innerHTML = '<div class="na-comp" style="color:var(--tiny,#8696a0);font-size:12.5px">Loading…</div>';
  try {
    var res = await api('/api/news/comments?id=' + id);
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || !d || !d.ok) { slot.innerHTML = '<div class="na-comp">' + esc((d && d.error) || 'Not available') + '</div>'; return; }
    var rows = (d.comments || []).map(function (c) {
      return '<div style="font-size:12.5px;margin-bottom:4px"><b translate="no">' + esc(c.name) + '</b>' +
        (c.store ? ' <span style="color:var(--tiny,#8696a0)">(' + esc(c.store) + ')</span>' : '') + ' <span translate="no">' + esc(c.body) + '</span>' +
        (_isHO ? ' <span style="cursor:pointer" title="Remove" onclick="NewsAdmin.deleteComment(' + c.id + ',' + id + ')">🗑</span>' : '') + '</div>';
    }).join('');
    slot.innerHTML = '<div class="na-comp">' + (rows || '<span style="color:var(--tiny,#8696a0);font-size:12.5px">No comments yet.</span>') + '</div>';
  } catch (e) {
    slot.innerHTML = '<div class="na-comp">Could not load comments.</div>';
  }
}

async function deleteComment(id, postId) {
  try {
    var res = await api('/api/admin/news/comment-delete', { method: 'POST', body: JSON.stringify({ id: id }) });
    if (res.ok) { toast('Comment removed'); _openComments = null; toggleComments(postId); }
  } catch (e) { toast('Could not remove', 'error'); }
}

async function archive(id, arch) {
  try {
    var res = await api('/api/admin/news/archive', { method: 'POST', body: JSON.stringify({ id: id, restore: !arch }) });
    if (res.ok) { toast(arch ? 'Archived' : 'Restored'); refresh(); }
  } catch (e) { toast('Could not update', 'error'); }
}

async function toggleCompliance(id) {
  var slot = document.getElementById('naComp' + id);
  if (!slot) return;
  if (_openCompliance === id) { _openCompliance = null; slot.innerHTML = ''; return; }
  _openCompliance = id;
  slot.innerHTML = '<div class="na-comp" style="color:var(--tiny,#8696a0);font-size:12.5px">Loading…</div>';
  try {
    var res = await api('/api/admin/news/compliance?id=' + id);
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || !d || !d.ok) { slot.innerHTML = '<div class="na-comp">' + esc((d && d.error) || 'Not available') + '</div>'; return; }
    var c = d.compliance;
    var rows = (c.stores || []).map(function (s) {
      return '<div class="na-store"><b>' + esc(s.store) + '</b> — ' + s.confirmed + '/' + s.total + ' (' + s.pct + '%)' +
        '<div class="na-bar"><div class="na-fill" style="width:' + s.pct + '%"></div></div>' +
        (s.names && s.names.missing && s.names.missing.length
          ? '<div class="na-names">Still to read: <span translate="no">' + esc(s.names.missing.join(', ')) + '</span></div>' : '') +
        '</div>';
    }).join('');
    slot.innerHTML = '<div class="na-comp"><b>' + c.confirmed + '/' + c.total + ' confirmed (' + c.pct + '%)</b>' +
      '<div style="margin-top:8px">' + (rows || '<span style="color:var(--tiny,#8696a0);font-size:12.5px">No staff in the audience yet.</span>') + '</div></div>';
  } catch (e) {
    slot.innerHTML = '<div class="na-comp">Could not load compliance.</div>';
  }
}

// v125.14 CRITICAL: handlers are EXPORTED, not on `window.NewsAdmin = {…}` —
// esbuild's `globalName:'NewsAdmin'` assigns the module EXPORTS to
// window.NewsAdmin, clobbering any in-body assignment, so an unexported handler
// = a dead `onclick="NewsAdmin.publish()"`. (See src/news for the full note.)
// v126.57 — tick every store in an area. Shared helper: a SNAPSHOT that ticks
// the checkboxes, not a new audience kind (see src/shared/areaPick.js).
function pickArea(areaId) { pickAreaStores('naStoreCb', areaId); }

export {
  pickArea,                              // v126.57 area quick-pick
  esc, fmtWhen,
  render, publish, archive, toggleCompliance, toggleComments, deleteComment, audChanged, imgPicked,
  attachPicked, attachRemove, openAttachment,         // v125.84 document slot; v129.113 several
  setDaily, previewBrief, runBriefNow,
  setToyNews, previewToyNews, runToyNewsNow, saveToyDomains,   // v132.4 — 🧸 This week in toys
  startEdit, cancelEdit,                              // v126.68 — edit a published post
  onSearch,                                           // v126.71 — search the admin news list
};
